type Props = {
  json?: string;
  jsonLd?: Record<string, any>;
};

const MainJsonLD = ({ jsonLd, json }: Props) => {
  if (!jsonLd && !json) return null;
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: jsonLd ? JSON.stringify(jsonLd) : json!,
      }}
    />
  );
};

export default MainJsonLD;
